/*
 * DashboardContainer Messages
 *
 * This contains all the text for the DashboardContainer component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.DashboardContainer";

export default defineMessages(scope, {
  header: "This is the DashboardContainer component!",
  sessionExpired: "Your session has expired.",
  sessionExpiredContent: "Please log in to your account again to continue.",
  sessionExpiringSoon: "Session times out soon.",
  sessionExpiringSoonContent:
    "For your security, you’ll be signed out in {dialogContent}.",
  keepWorking: "Keep working",
  signOut: "Sign out",
  signIn: "Sign in",
});
